import "./styles.scss";

import { FaCheck } from "react-icons/fa6";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";

import logoAndroidIosPNG from "../../../assets/images/icons/icon_ios_android.svg";

function CardInfo() {
  const { t } = useTranslation();

  const itemDescriptionArray = [
    { id: "1", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_AFFILIATE1" },
    { id: "2", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_AFFILIATE2" },
    { id: "3", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_AFFILIATE3" },
    { id: "4", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_AFFILIATE4" },
    { id: "5", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_AFFILIATE5" },
    { id: "6", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_AFFILIATE6" },
    { id: "7", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_AFFILIATE7" },
    { id: "8", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_AFFILIATE8" },
    { id: "9", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_AFFILIATE9" },
  ];

  return (
    <div className="affiliateCardInfoContainer">
      <div className="affiliateCardInfoHeaderCard">
        <span className="affiliateCardInfoPlanName">{t("AFFILIATE_PROGRAM_TITLE")}</span>

        <div className="affiliateCardInfoWrapperLanguage">
          <FlagIcon size={25} code="US" />
          <FlagIcon size={25} code="BR" />
          <FlagIcon size={25} code="ES" />
          <FlagIcon size={25} code="FR" />
        </div>

        <span className="affiliateCardInfoDescriptionHeader">{t("AFFILIATE_PROGRAM_DESCRIPTION")}</span>
      </div>

      <div className="affiliateCardInfoDescriptionCard">
        {itemDescriptionArray.map((item) => (
          <div className="affiliateCardInfoItemDescriptionCard" key={item.id}>
            <div>{item.icon}</div> <span>{t(item.name)}</span>
          </div>
        ))}

        <div className="affiliateCardInfoItemDescriptionCard">
          <div>
            <FaCheck size={20} color="#00c6ff" />
          </div>
          <span>{t("ITEM_CARD_INFO8")} </span>
          <img src={logoAndroidIosPNG} />
        </div>
      </div>
    </div>
  );
}

export default CardInfo;
